export default __webpack_public_path__ + "static/40-a0dd2c72e6a9784d9e33aab3b5da6260.png";